<template>
    <transition name="modal">
        <div
            class="modal-mask fixed z-50 bg-brand-95 w-full h-full top-0 left-0 flex items-center justify-center flex-col"
        >
            <div
                class="modal-container container px-4 fade-out overflow-y-scroll w-full h-full no-scrollbar"
            >
                <div class="modal-header mt-16">
                    <h2 class="font-serif font-bold text-white">
                        <slot name="header"> {{ data.title }} </slot>
                    </h2>
                    <p class="font-sans text-white text-2xl md:text-4xl">
                        <slot name="header">{{ data.type }} </slot>
                    </p>
                </div>
                <div
                    class="modal-body font-sans text-white overflow-hidden py-8 md:py-16"
                    v-html="data.body"
                    v-if="data.body"
                ></div>
            </div>

            <div class="modal-footer py-8 container px-4 flex flex-wrap">
                <slot name="footer">
                    <a
                        class="text-white font-sans w-full"
                        :href="'mailto:' + data.email"
                        >{{ data.email }}</a
                    >
                    <a
                        class="text-white font-sans w-full"
                        :href="'tel:' + data.phone"
                        >{{ data.phone }}</a
                    >
                </slot>
            </div>

            <button
                class="absolute right-0 mr-5 mt-2 top-0 font-serif text-white font-bold text-4xl z-50"
                @click="$emit('close')"
            >
                X
            </button>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        data: Object,
    },
};
</script>

<style>
.modal-mask {
    transition: opacity 0.3s ease;
}

.modal-body p {
    color: white;
}

.modal-container {
    transition: all 0.3s ease;
}

.no-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

.no-scrollbar::-webkit-scrollbar {
    display: none;
}

.fade-out {
    -webkit-mask-image: linear-gradient(to bottom, black 88%, transparent 100%);
    mask-image: linear-gradient(to bottom, black 88%, transparent 100%);
}

.fade-in {
    -webkit-mask-image: linear-gradient(to top, black 70%, transparent 100%);
    mask-image: linear-gradient(to top, black 70%, transparent 100%);
}
/*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
